module.exports = __webpack_public_path__ + "img/icon_success.1aaa4c78.png";